import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { environment } from '@environments';
import { NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ProductoService } from '@abm/producto/producto.service';
import { Lote } from '@shared/models/precios/Lote';
import { PrecioAprobacion } from '@shared/models/precios/PrecioAprobacion';
import { UntypedFormGroup } from '@angular/forms';
import { TipoPrecioReporte } from '@shared/enums/TipoPrecioReporte';
import { ConsultaPrecioFacturaDTO } from '@shared/models/precios/ConsultaPrecioFacturaDTO';
import { MessageService } from '@shell/message.service';
import { ErrorModel } from "@shared/models/ErrorModel";
import { ExportExcelServiceService } from "@shared/exportar-excel/export-excel-service.service";

@Component({
  selector: 'app-descarga-precios',
  templateUrl: './descarga-precios.component.html',
  styleUrls: ['./descarga-precios.component.css']
})
export class DescargaPreciosComponent implements OnInit {

  @Output() cancelado = new EventEmitter();

  TipoPrecioReporte = TipoPrecioReporte;
  messageDescarga: string = "C a r g a n d o . . . ";
  loading: boolean = false;
  descargando: boolean = false;
  obteniendoPreciosScroll: boolean = false;

  tipoPrecioReporte: TipoPrecioReporte = TipoPrecioReporte.PreciosSubidos;
  listadoPreciosSubidos: Lote[] = [];
  listadoPreciosAprobados: PrecioAprobacion[] = [];
  listadoPreciosFacturados: ConsultaPrecioFacturaDTO[] = [];
  modelDesde: NgbDateStruct;
  modelHasta: NgbDateStruct;
  fechaDesde: Date;
  fechaHasta: Date;

  throttle = 500;
  distance = 0;
  page = 0;
  pageSize = 1000;
  stopScroll:boolean;

  tablaPreciosAprobados = new UntypedFormGroup({ });
  tablaPreciosSubidos = new UntypedFormGroup({ });
  tablaPreciosFacturados = new UntypedFormGroup({ })

  private exportando: boolean = false;

  constructor(
      private spinner: NgxSpinnerService,
      private http: HttpClient,
      private calendar: NgbCalendar,
      private messageService: MessageService,
      private productoService: ProductoService,
      private excelService: ExportExcelServiceService) { }

  ngOnInit() {
    this.modelDesde = this.calendar.getToday();
    this.fechaDesde = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    this.modelHasta = this.calendar.getToday();
    this.fechaHasta = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    this.getLotes();
  }
  

  handleLoading(show: boolean, message?: string) {
    this.loading = show;
    this.messageDescarga = message ?? "C a r g a n d o . . . ";
    show ? this.spinner.show('spinnerLista') : this.spinner.hide('spinnerLista');
  }

  getLotes() {
    this.handleLoading(true);

    this.productoService.getLotesPorFecha(this.stringFechaDesde(), this.stringFechaHasta())
      .subscribe(result => {
        this.listadoPreciosSubidos = result;
        this.handleLoading(false);
      });
  }

  getLotesAprobacion() {
    this.handleLoading(true);

    this.productoService.getLotesAprobacion(this.stringFechaDesde(), this.stringFechaHasta())
      .subscribe(result => {
        this.listadoPreciosAprobados = result;
        this.handleLoading(false);
      });
  }

  getPreciosFacturados() {
    this.handleLoading(true);

    if (this.rangoExcedeDias()) {
      this.messageService.showErrorMessage('El rango de fecha excede los 31 días.');
      this.handleLoading(false);
      return
    }

    this.productoService.getPreciosFacturados(this.stringFechaDesde(), this.stringFechaHasta(), ++this.page, this.pageSize)
      .subscribe(result => {
        console.log(result);
        this.listadoPreciosFacturados = result;
        this.handleLoading(false);
      }, () => {
        this.stopScroll = true;
        this.handleLoading(false);
      });
  }

  initRequest(isScroll: boolean) {// eslint-disable-line
    this.mostrarSpinnerScroll();
  }

  mostrarSpinnerScroll() {
    this.obteniendoPreciosScroll = true;
  }

  ocultarSpinnerScroll() {
    this.obteniendoPreciosScroll = false;
  }

  procesarResult(preciosFacturados, isScroll: boolean) {
    preciosFacturados?.length==0 ? this.stopScroll=true : this.stopScroll=false;
    console.log('stop scrolling: ', this.stopScroll);
    if (!isScroll) {
      this.listadoPreciosFacturados = preciosFacturados;
    } else {
      this.listadoPreciosFacturados = this.listadoPreciosFacturados.concat(preciosFacturados);
      this.ocultarSpinnerScroll();
    }
  }

  procesarError(error, isScroll: boolean) {
    if (!isScroll) {
      this.messageService.showErrorMessage('Hubo un error al obtener los datos. ' + error.description);
    } else if (isScroll) {
      this.messageService.showErrorMessage('Hubo un error al obtener los datos en el scroll. ' + error.description);
      this.ocultarSpinnerScroll();
    }
  }

  onScrollPrecios(){
    this.initRequest(true);
    this.productoService.getPreciosFacturados(this.stringFechaDesde(), this.stringFechaHasta(), ++this.page, this.pageSize)
      .subscribe(res => {
          this.procesarResult(res, true);
        }, (err: ErrorModel) => {
          this.procesarError(err, true);
        }
      );
  }

  stringFechaDesde(){
    this.fechaDesde = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    const desde: string = this.formatDate(this.fechaDesde.getFullYear(), this.fechaDesde.getMonth() + 1, this.fechaDesde.getDate(), 0, 0);

    return desde;
  }

  stringFechaHasta(){
    this.fechaHasta = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    const hasta: string = this.formatDate(this.fechaHasta.getFullYear(), this.fechaHasta.getMonth() + 1, this.fechaHasta.getDate(), 23, 59);

    return hasta;
  }

  cambiarTabla(tipoPrecio: number){
    if(tipoPrecio == TipoPrecioReporte.PreciosSubidos){
      this.tipoPrecioReporte =  TipoPrecioReporte.PreciosSubidos;
      this.page = 0;
      this.getLotes();
    }else if(tipoPrecio == TipoPrecioReporte.PreciosAprobados){
      this.tipoPrecioReporte =  TipoPrecioReporte.PreciosAprobados;
      this.page = 0;
      this.getLotesAprobacion();
    }else if(tipoPrecio == TipoPrecioReporte.PreciosFacturados){
      this.tipoPrecioReporte =  TipoPrecioReporte.PreciosFacturados;
      this.page = 0;
      this.listadoPreciosFacturados = [];
      this.getPreciosFacturados();
    }
  }

  buscardatos(){
    if (this.tipoPrecioReporte === TipoPrecioReporte.PreciosFacturados && this.rangoExcedeDias()) {
      this.messageService.showErrorMessage('El rango de fecha excede los 31 días.');
      return  
    }

    if(this.tipoPrecioReporte == TipoPrecioReporte.PreciosSubidos){
      this.getLotes();
    }else if(this.tipoPrecioReporte == TipoPrecioReporte.PreciosAprobados){
      this.getLotesAprobacion();
    } else {
      this.page = 0;
      this.getPreciosFacturados();
    }
  }

  rangoExcedeDias() {
    const diferenciaMs = this.fechaHasta.getTime() - this.fechaDesde.getTime();

    // Convierto a días y verifico si excede los 31 dias
    const diferenciaDias = Math.abs(diferenciaMs / (1000 * 60 * 60 * 24));
    return diferenciaDias > 31;
  }

  fechaDesdeMayorQueHasta() {
    let esMayor: boolean = false;
    this.fechaDesde = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    this.fechaHasta = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    if (this.fechaDesde > this.fechaHasta) { esMayor = true; }
    return esMayor;
  }

  formatDate(year, month, day, hour, minute): string {
    return year + '/' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '/' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':00';
  }

  volver() {
    this.cancelado.emit(true);
  }

  descargarPreciosAprobados(i: number) {
    this.descargando = true;
    this.listadoPreciosAprobados[i].loadIcon = true;
    ///api/ExportarV1/ReportePreciosPDF?aprobacion=false
    const url = `${environment.apiServer.productosUrl}/ExportarV1/ReportePreciosPDF?aprobacion=true`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    let loteADescargar: string = "";
    loteADescargar = "\"" + this.listadoPreciosAprobados[i].id +  "\"";
    // Process the file downloaded
    this.http.put(url, loteADescargar, { headers: headers, responseType: 'blob' as 'json' })
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/pdf;' });
        saveAs(blob, "reporte-precios-aprobados-" + this.listadoPreciosAprobados[i].fechaAprobacion + ".pdf")
        this.spinner.hide('spinnerGrafico');
        this.listadoPreciosAprobados[i].loadIcon = false;
        this.descargando = false;
      }, () => {
        console.log("No se encontraron lotes para exportar");
        this.spinner.hide('spinnerGrafico');
        this.descargando = false;
      });
  }

  descargarPreciosSubidos(i: number) {
    this.descargando = true;
    this.listadoPreciosSubidos[i].loadIcon = true;
    const url = `${environment.apiServer.productosUrl}/ExportarV1/ReportePreciosPDF?aprobacion=false`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    let loteADescargar: string = "";
    loteADescargar = "\"" + this.listadoPreciosSubidos[i].id +  "\"";
    // Process the file downloaded
    this.http.put(url, loteADescargar, { headers: headers, responseType: 'blob' as 'json' })
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/pdf;' });
        saveAs(blob, "reporte-precios-importados-LoteN°" + this.listadoPreciosSubidos[i].numeroLote + ".pdf")
        this.spinner.hide('spinnerGrafico');
        this.listadoPreciosSubidos[i].loadIcon = false;
        this.descargando = false;
      }, () => {
        console.log("No se encontraron precios para exportar");
        this.spinner.hide('spinnerGrafico');
        this.listadoPreciosSubidos[i].loadIcon = false;
        this.descargando = false;
      });
  }

  async armarArrayExcel(): Promise<ConsultaPrecioFacturaDTO[]> {
    let pageAux = 1;
    const listadoPrecios: ConsultaPrecioFacturaDTO[] = [];

    this.handleLoading(true, "Generando excel...");
    while (true) {// eslint-disable-line
      try {
        const result = await this.productoService.getPreciosFacturados(
          this.stringFechaDesde(),
          this.stringFechaHasta(),
          pageAux,
          this.pageSize
        ).toPromise();

        listadoPrecios.push(...result);

        if (result.length < this.pageSize) break;
        pageAux++;
      } catch (error) {
        this.messageService.showErrorMessage('Error: No se pudo crear el excel. ' + error.description);
        throw error;
      } finally {
        this.handleLoading(false);
      }
    }

    return this.armarListadoExcel(listadoPrecios);
  }

  armarListadoExcel(listado: ConsultaPrecioFacturaDTO[]) {
    const listaReporte: ConsultaPrecioFacturaDTO[] = [];
    for (const l of listado) {
      const item = new ConsultaPrecioFacturaDTO();
      item.aerovale = l.aerovale;
      item.matricula = l.matricula;
      item.productoCodigo = l.productoCodigo;
      item.productoNombre = l.productoNombre;
      item.unidadDeMedida = l.unidadDeMedida;
      item.cantidad = l.cantidad;
      item.tipoOperacion = l.tipoOperacion;
      item.rancho = l.rancho;
      item.fechaDespacho = l.fechaDespacho;
      item.codigoAeroplantaDespacho = l.codigoAeroplantaDespacho;
      item.numeroAeroplantaDespacho = l.numeroAeroplantaDespacho;
      item.numeroAeroplantaDespacho = l.numeroAeroplantaDespacho;
      item.descripcionAeroplantaDespacho = l.descripcionAeroplantaDespacho;
      item.ciudadDeDespacho = l.ciudadDeDespacho;
      item.codigoDireccionDeEntrega = l.codigoDireccionDeEntrega;
      item.ciudadDireccionDeEntrega = l.ciudadDireccionDeEntrega;
      item.prefijoRemito = l.prefijoRemito;
      item.numeroRemito = l.numeroRemito;
      item.centroEmisorFactura = l.centroEmisorFactura;
      item.numeroFactura = l.numeroFactura;
      item.letraFactura = l.letraFactura;
      item.fechaFactura = l.fechaFactura;
      item.fechaVencimiento = l.fechaVencimiento;
      item.codigoAeroplantaFactura = l.codigoAeroplantaFactura;
      item.numeroAeroplantaFactura = l.numeroAeroplantaFactura;
      item.nombreAeroplantaFactura = l.nombreAeroplantaFactura;
      item.codigoMonedaFactura = l.codigoMonedaFactura;
      item.descripcionMonedaFactura = l.descripcionMonedaFactura;
      item.clienteCuenta = l.clienteCuenta;
      item.clienteDocumento = l.clienteDocumento;
      item.clienteRazonSocial = l.clienteRazonSocial;
      item.lotePrecio = l.lotePrecio;
      item.nivelPrecio = l.nivelPrecio;
      item.areaPrecio = l.areaPrecio;
      item.segmentoPrecio = l.segmentoPrecio;
      item.monedaPrecio = l.monedaPrecio;
      item.codigoDireccionDeEntregaPrecio = l.codigoDireccionDeEntregaPrecio;
      item.fechaDesde = l.fechaDesde;
      item.fechaHasta = l.fechaHasta;
      item.precioFacturado = l.precioFacturado;
      item.precioLista = l.precioLista;
      item.tipoBonificacionRecargo = l.tipoBonificacionRecargo;
      item.valorBonificacionRecargo = l.valorBonificacionRecargo;
      item.valorIva = l.valorIva;
      item.valorIIBB = l.valorIIBB;
      item.percepcionIva = l.percepcionIva;
      item.valorIDC = l.valorIDC;
      item.valorICL = l.valorICL;
      item.porcentajeBIO = l.porcentajeBIO;
      item.comercial = l.comercial;
      item.cuentaSap = l.cuentaSap;
      item.comentarioAerovale = l.comentarioAerovale;
      item.expendedora = l.expendedora;
      listaReporte.push(item);
    }
    return listaReporte;
  }

  async exportar() {
    if (this.exportando) {
      this.messageService.showWarningMessage('Exportación en curso, por favor espere...');
      return;
    }

    this.exportando = true;

    try {
      const cargaCompleta = !this.stopScroll && this.listadoPreciosFacturados.length >= this.pageSize;
      const data = cargaCompleta ? await this.armarArrayExcel() : this.armarListadoExcel(this.listadoPreciosFacturados);
      const fileName = 'FechaDesde:' + this.stringFechaDesde() + 'fechaHasta:' + this.stringFechaHasta() + 'ReportePreciosUtilizados';
      this.excelService.exportAsExcelFile(data, fileName);
    } catch (error) {
      this.messageService.showErrorMessage('Error: No se pudo crear el excel. ' + error.description);
    } finally {
      this.exportando = false;
    }
  }

}
